import React from "react";

const Sidebar = ({ activeMenu, setActiveMenu, visible, onClose, userAccess }) => {
  const menuSections = [
    {
      title: "Fixed Asset",
      code: 1300,
      items: [
        { label: "Master Aset", icon: "💻", key: "master-aset" },
        { label: "Add Asset", icon: "➕", key: "add-asset" },
      ],
    },
    {
      title: "Procurement",
      code: 1302,
      items: [
        { label: "Master Barang", icon: "📋", key: "master-barang" },
        { label: "Purchase Order", icon: "📝", key: "purchase-order" },
      ],
    },
    {
      title: "Inventory",
      code: 1301,
      items: [
        { label: "Permintaan Barang", icon: "📦", key: "permintaan-barang" },
        { label: "Purchase Request", icon: "🧾", key: "purchase-request" },
      ],
    },
    {
      title: "Finance",
      code: 1303,
      items: [
        { label: "Request Of Payment", icon: "💰", key: "pengajuan-rop" },
      ],
    },
  ];

  // 🔹 Filter menu berdasarkan akses user
  const visibleMenus = menuSections.filter((section) =>
    userAccess.includes(section.code)
  );

  if (!visibleMenus.length) {
    return (
      <div
        style={{
          padding: "20px",
          background: "#fff",
          borderRight: "1px solid #ddd",
          color: "#666",
        }}
      >
        Tidak ada menu tersedia.
      </div>
    );
  }

  // 🔹 Tentukan mode & ukuran sidebar
  const isMobile = window.innerWidth < 768;
  const sidebarWidth = isMobile ? "220px" : "280px";

  return (
    <aside
      style={{
        position: "fixed",
        top: "64px", // di bawah navbar
        left: visible
          ? "0"
          : isMobile
          ? `-${sidebarWidth}` // sembunyikan kalau mobile & tidak visible
          : "0", // tetap tampil di desktop
        height: "calc(100vh - 64px)",
        width: sidebarWidth,
        background: "#ffffff",
        borderRight: "1px solid #e5e7eb",
        boxShadow: visible && isMobile ? "2px 0 8px rgba(0,0,0,0.08)" : "none",
        overflowY: "auto",
        transition: "left 0.3s ease, box-shadow 0.3s ease",
        zIndex: 200,
        padding: visible ? "16px" : "0",
      }}
    >
      {/* 📋 Menu Section */}
      {visibleMenus.map((section) => (
        <div key={section.title} style={{ marginBottom: "24px" }}>
          <h4
            style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "10px",
              background: "#05386bff",
              padding: "8px 12px",
              borderRadius: "6px",
              color: "#f4f3f9ff",
            }}
          >
            {section.title}
          </h4>

          {section.items.map((item) => (
            <div
              key={item.key}
              onClick={() => {
                setActiveMenu(item.key);
                if (isMobile) onClose(); // ✅ auto-close saat mobile
              }}
              style={{
                padding: "8px 10px",
                borderRadius: "6px",
                background:
                  activeMenu === item.key ? "#007bff" : "transparent",
                color: activeMenu === item.key ? "#fff" : "#333",
                cursor: "pointer",
                marginBottom: "6px",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "18px" }}>{item.icon}</span>
              <span style={{ flex: 1, fontSize: "14px" }}>{item.label}</span>
            </div>
          ))}
        </div>
      ))}
    </aside>
  );
};

export default Sidebar;
